export default {
  hero: {
    titleLetter: 'A',
    titleRest: 'utomatize sua jornada',
    titleIn: 'no',
    subtitle: 'Rápido, leve e 100% seguro',
    viewAccount: 'Ver Conta',
    loginRegister: 'Entrar / Registrar',
    download: 'Baixar Unity-BOT',
    downloadNow: 'Baixar Agora',
    version: 'Versão {v}',
    versionSize: 'Versão {v} • {size}',
    changelogUnavailable: 'Nenhum changelog disponível.',
    windowsReq: 'Windows 7+',
    ramReq: '4 GB de RAM',
    javaReq: 'Java JDK 20+',
    admin: 'Admin',
    logoAlt: 'Logo Unity-BOT',
  },
  features: {
    title: 'Recursos',
    items: [
      { title: 'Configuração Fácil', desc: 'Auto-checker com configuração avançada simplificada' },
      { title: 'Ações Especiais', desc: 'Automatize missões com ações como usar itens, falar com NPCs e mais' },
      { title: 'Comunidade Ativa', desc: 'Comunidade ativa com atualizações constantes' },
    ],
  },
  download: {
    guidesTitle: 'Guias & Tutoriais',
    communityTitle: 'Junte-se à Comunidade',
    tutorial: 'Tutorial',
    tutorialDesc: 'Assista nosso guia completo de configuração no YouTube',
    facebook: 'Facebook',
    facebookDesc: 'Participe da nossa comunidade no Facebook para notícias e atualizações',
    whatsApp: 'WhatsApp',
    whatsAppDesc: 'Obtenha suporte instantâneo e conecte-se com outros usuários no WhatsApp',
    discord: 'Discord',
    discordDesc: 'Entre no nosso servidor Discord para chat ao vivo e suporte técnico',
  },
  footer: {
    copyright: '© 2026 Unity-BOT. Todos os direitos reservados.',
    about: 'Sobre',
    disclaimer: 'Unity-BOT não é afiliado à CipSoft GmbH. Este software é apenas para fins educacionais.',
  },
  about: {
    title: 'Sobre o Unity-BOT',
    botName: 'Unity-BOT v3.0 BETA',
    botDesc: '{name} é uma ferramenta de automação sofisticada projetada especificamente para TibiaME, representando anos de desenvolvimento e feedback da comunidade. Construído com precisão e eficiência, transforma a forma como os jogadores experienciam o jogo automatizando tarefas tediosas enquanto mantém os mais altos padrões de segurança e desempenho.',
    coreFeatures: 'Recursos Principais',
    smartHunt: 'Auto-Caça Inteligente',
    smartHuntDesc: 'Sistema avançado de pathfinding com rotas personalizáveis, seleção prioritária de criaturas, coleta de loot e gerenciamento automático de mochila',
    smartHeal: 'Auto-Cura Inteligente',
    smartHealDesc: 'Algoritmo de cura preditivo que monitora HP/MP em tempo real, com limites configuráveis e failovers de emergência',
    questAuto: 'Automação de Missões',
    questAutoDesc: 'Fluxos completos de missões incluindo diálogos com NPCs, entrega de itens e execução de missões de múltiplas etapas',
    skillTrain: 'Treino Automático de Habilidades',
    skillTrainDesc: 'Otimize a progressão de habilidades com rotinas de treino automatizadas para habilidades corpo a corpo, à distância e mágicas',
    advancedCaps: 'Capacidades Avançadas',
    actionScript: 'Sistema de Script de Ações',
    actionScriptDesc: 'Crie sequências personalizadas: use itens, fale com NPCs, navegue por coordenadas e encadeie múltiplas ações com lógica condicional',
    autoChecker: 'Sistema Auto-Checker',
    autoCheckerDesc: 'Monitoramento em tempo real com alertas configuráveis para HP, MP, capacidade, detecção de criaturas e gatilhos personalizados',
    antiDetect: 'Tecnologia Anti-Detecção',
    antiDetectDesc: 'Padrões de comportamento humanizados, atrasos aleatórios e tempos de resposta inteligentes para manter uma jogabilidade natural',
    resourceOpt: 'Otimização de Recursos',
    resourceOptDesc: 'Design ultraleve (< 50MB de RAM), baixo uso de CPU e manipulação eficiente de rede',
    safetyTitle: 'Segurança & Desempenho',
    safety1: 'Sem injeção de memória - opera através de captura de tela e simulação de entrada',
    safety2: 'Sistemas de segurança multicamadas para evitar morte de personagem',
    safety3: 'Mecanismos anti-trava e recuperação de erros integrados',
    safety4: 'Painel de estatísticas em tempo real com rastreamento de sessão',
    safety5: 'Atualizações regulares e correções de bugs da equipe de desenvolvimento ativa',
    communityTitle2: 'Comunidade & Suporte',
    communityDesc: 'Junte-se a milhares de jogadores em nossa comunidade vibrante. Acesse guias completos, compartilhe scripts personalizados, obtenha suporte técnico e contribua para a evolução do bot. Nosso servidor Discord está ativo 24/7 com usuários experientes e desenvolvedores prontos para ajudar.',
    tibiameTitle: 'TibiaME',
    tibiameDesc1: '{name} (Tibia Micro Edition) é o primeiro MMORPG massivamente multiplayer para dispositivos móveis, lançado em 2003. Baseado no clássico {classic}, o jogo permite que centenas de jogadores se conectem simultaneamente para explorar um mundo virtual colorido.',
    tibiameDesc2: 'No jogo, você pode explorar terras misteriosas, lutar contra hordas de criaturas malignas, resolver enigmas antigos, encontrar tesouros escondidos e crescer em força e poder a cada monstro derrotado.',
    tibiameAvailable: 'Disponível para iOS e Android',
    cipsoftTitle: 'CipSoft GmbH',
    cipsoftDesc: '{name} é uma desenvolvedora independente alemã de jogos online, fundada após o sucesso de {classic} - um dos primeiros MMORPGs da história, online desde 1997. A empresa tem mais de 100 funcionários e é reconhecida internacionalmente.',
    cipsoftTibia: '{game} (1997) - MMORPG clássico de navegador',
    cipsoftTibiame: '{game} (2003) - Primeiro MMORPG mobile',
    cipsoftSettlers: '{game} - Jogo de estratégia',
    cipsoftPersist: '{game} - Novo MMORPG zumbi (em desenvolvimento)',
    cipsoftAward: 'Vencedor do German Developer Award 2019 por Tibia',
    legalNotice: 'Aviso Legal',
    legalDesc1: '{name} é um projeto independente e não é afiliado, endossado ou patrocinado pela CipSoft GmbH. TibiaME e Tibia são marcas registradas da CipSoft GmbH.',
    legalDesc2: 'O uso de ferramentas de automação pode violar os Termos de Serviço do jogo. Use por sua conta e risco.',
    version: 'Unity-BOT v3.0 BETA',
    copyright: '© 2026 Unity-BOT Team',
  },
  auth: {
    enterRealm: 'Entre no Reino',
    joinGuild: 'Junte-se à Guilda',
    verifyEmail: 'Verifique seu Email',
    recoverAccount: 'Recupere sua Conta',
    createNewPassword: 'Crie uma Nova Senha',
    setNewPassword: 'Defina Nova Senha',
    authentication: 'Autenticação',
    enter: 'Entrar',
    createAccount: 'Criar Conta',
    sendResetLink: 'Enviar Link de Reset',
    verifyEmailBtn: 'Verificar Email',
    resetPassword: 'Redefinir Senha',
    setNewPasswordBtn: 'Definir Nova Senha',
    submit: 'Enviar',
    username: 'Usuário',
    usernamePlaceholder: 'Digite seu usuário',
    email: 'Email',
    emailPlaceholder: 'Digite seu email',
    forgotEmailPlaceholder: 'Digite o email da sua conta',
    password: 'Senha',
    passwordPlaceholder: 'Digite sua senha',
    newPassword: 'Nova Senha',
    newPasswordPlaceholder: 'Digite sua nova senha',
    changePasswordPlaceholder: 'Crie uma nova senha',
    strongPasswordHint: 'Escolha uma senha forte que você não usou antes.',
    confirmPassword: 'Confirmar Senha',
    confirmPasswordPlaceholder: 'Confirme sua senha',
    forgotHint: 'Enviaremos um link de redefinição de senha para este email.',
    verificationCode: 'Código de Verificação de 6 Dígitos',
    verificationCodePlaceholder: '000000',
    codeSentTo: 'Digite o código de 6 dígitos enviado para',
    attemptsRemaining: '{n} tentativa{s} restante{plural}',
    resendCode: 'Não recebeu o código? Reenviar',
    codeExpired: 'Código expirado - Clique para obter novo código',
    forgotPassword: 'Esqueceu sua senha?',
    noAccount: 'Não tem uma conta?',
    haveAccount: 'Já tem uma conta?',
    login: 'Entrar',
    rememberPassword: 'Lembrou sua senha?',
    backToLogin: 'Voltar ao Login',
    needToGoBack: 'Precisa voltar?',
    loginFailed: 'Falha no login',
    registrationFailed: 'Falha no registro',
    registrationSuccess: 'Registro bem-sucedido! Verifique seu email para um código de verificação de 6 dígitos.',
    emailNeedsVerification: 'Seu email precisa ser verificado. Verifique sua caixa de entrada para o código de verificação.',
    passwordIsTemporary: 'Sua senha é temporária. Por favor, defina uma nova senha.',
    verificationFailed: 'Falha na verificação de email',
    verificationSuccess: 'Email verificado com sucesso! Você já pode entrar.',
    verificationCodeExpired: 'O código de verificação expirou. Solicite um novo.',
    resendSuccess: 'Novo código de verificação enviado! Verifique seu email.',
    resendFailed: 'Falha ao reenviar código de verificação',
    usernameNotFound: 'Usuário não encontrado. Por favor, registre-se novamente.',
    validEmailRequired: 'Por favor, insira um email válido',
    passwordsDoNotMatch: 'As senhas não conferem',
    passwordMinLength: 'A senha deve ter pelo menos 6 caracteres',
    resetLinkSent: 'O link de redefinição de senha foi enviado para seu email. Verifique sua caixa de entrada e pasta de spam. O link expirará em 1 hora.',
    resetLinkFailed: 'Não foi possível processar sua solicitação. Verifique seu email e tente novamente.',
    invalidResetLink: 'Link de redefinição inválido. Solicite uma nova redefinição de senha.',
    resetSuccess: 'Senha redefinida com sucesso! Você já pode entrar com sua nova senha.',
    resetFailed: 'Falha ao redefinir senha. O link pode ter expirado.',
    changePasswordFailed: 'Falha ao alterar senha',
    unexpectedError: 'Ocorreu um erro inesperado. Tente novamente.',
    loading: 'Carregando...',
  },
  account: {
    title: 'Conta',
    leave: 'Sair',
    setNickname: '+ Definir apelido',
    editNickname: 'Editar apelido',
    save: 'Salvar',
    cancel: 'Cancelar',
    aka: 'aka "{nickname}"',
    retry: 'Tentar novamente',
    nicknameEmpty: 'O apelido não pode estar vazio',
    nicknameMax: 'O apelido deve ter no máximo 30 caracteres',
    nicknameMin: 'O apelido deve ter pelo menos 3 caracteres',
    nicknameBrackets: 'O apelido não pode usar colchetes no início ou fim',
    nicknameSpaces: 'O apelido não pode conter múltiplos espaços consecutivos ou espaços especiais',
    nicknameChars: 'O apelido pode conter apenas letras, números, espaços, hífens e underlines',
    nicknamePrefix: 'O apelido não pode começar com "{prefix}"',
    nicknameForbidden: 'Este apelido contém palavras ou padrões proibidos',
    nicknameProfanity: 'O apelido não pode conter linguagem inadequada',
    nicknameRepetitive: 'O apelido contém padrões repetitivos ou inválidos',
    nicknameUppercase: 'O apelido não pode ser maioritariamente maiúsculo',
    nicknameSystem: 'O apelido não pode conter palavras relacionadas ao sistema',
    free: 'Grátis',
    licensed: 'Licenciado',
    admin: 'Admin',
    active: 'Ativo',
    suspended: 'Suspenso',
    banned: 'Banido',
    unknown: 'Desconhecido',
    appOnline: 'APP: Online',
    appOffline: 'APP: Offline',
    siteOnline: 'Site: Online',
    siteOffline: 'Site: Offline',
    appTooltip: 'APP (Unity-BOT)',
    siteTooltip: 'Site (Website)',
    updating: 'Atualizando...',
    updated: 'Atualizado {time}',
    info: 'Info',
    email: 'Email:',
    accountStatus: 'Status da Conta:',
    reason: 'Motivo:',
    until: 'Até:',
    bannedBy: 'Banido por:',
    emailVerified: 'Email Verificado:',
    yes: 'Sim',
    no: 'Não',
    resendVerification: 'Reenviar email de verificação',
    sending: 'Enviando...',
    verificationSent: 'Email de verificação enviado!',
    verificationFailed: 'Falha ao enviar email de verificação',
    verificationFailed2: 'Não foi possível enviar email de verificação. Tente novamente mais tarde.',
    availableTabs: 'Tabs Disponíveis:',
    temp: '+{n} temp',
    permanent: 'Permanente:',
    activePackages: 'Pacotes Ativos:',
    tabs: '{n} tabs',
    expires: 'expira {date}',
    addedByAdmin: 'Adicionado por admin',
    characters: 'Personagens:',
    charsCount: '{count} ({online} online)',
    memberSince: 'Membro Desde:',
    memberForYears: 'Membro há {y}a {m}m',
    memberForMonths: 'Membro há {m}m',
    memberForDays: 'Membro há {d}d',
    memberForLess: 'Membro há < 1d',
    lastLogin: 'Último Login:',
    never: 'Nunca',
    na: 'N/A',
    justNow: 'agora mesmo',
    minsAgo: '{n}min atrás',
    hoursAgo: '{n}h atrás',
    daysAgo: '{n}d atrás',
    monthsAgo: '{n}meses atrás',
    charsTab: 'Personagens',
    loadingChars: 'Carregando personagens',
    noChars: 'Nenhum personagem encontrado',
    noCharsHint: 'Personagens aparecerão aqui quando criados no jogo',
    clickForDetails: 'Clique para ver detalhes',
    online: 'Online',
    offline: 'Offline',
    level: 'Nível {n}',
    security: 'Segurança',
    changePassword: 'Alterar Senha',
    currentPassword: 'Senha Atual',
    newPassword: 'Nova Senha',
    confirmPassword: 'Confirmar Senha',
    passwordPlaceholder: '••••••••',
    changing: 'Alterando...',
    changePwBtn: 'Alterar Senha',
    allFieldsRequired: 'Todos os campos são obrigatórios',
    newPasswordMin: 'A nova senha deve ter pelo menos 6 caracteres',
    newPasswordMismatch: 'As novas senhas não conferem',
    passwordChanged: 'Senha alterada com sucesso!',
    changePwFailed: 'Falha ao alterar senha',
    changePwError: 'Ocorreu um erro. Tente novamente.',
    buyTabs: 'Comprar Tabs',
    configurePackage: 'Configure seu Pacote',
    tabQuantity: 'Qtd. de Tabs',
    durationMonths: 'Duração (Meses)',
    presetBasic: 'Básico',
    presetPopular: 'Popular',
    presetPremium: 'Premium',
    presetUltimate: 'Ultimate',
    orderSummary: 'Resumo do Pedido',
    package: 'Pacote',
    packageDesc: '{n} tab{s} × {n} mês{es}',
    baseValue: 'Valor Base',
    discount: '-R$ {amount}',
    total: 'Total a Pagar',
    savingTip: 'Dica: Mais meses = Mais economia!',
    processing: 'Processando...',
    buyFor: 'Comprar por R$ {amount}',
    selectPackageFirst: 'Por favor, selecione a quantidade de tabs e duração',
    purchaseFailed: 'Falha ao processar pedido. Tente novamente ou contate o suporte.',
    purchaseSuccess: 'Pedido confirmado! Realize o pagamento via PIX para ativar suas tabs.',
    pixTitle: 'Escaneie o código QR ou copie o código abaixo',
    pixValue: 'Valor:',
    pixDesc: '{tabs} tab{s} por {months} mês{es}',
    pixCode: 'Código PIX (Copia e Cola)',
    withValue: 'Com Valor',
    copyCode: 'Copiar código PIX completo',
    copied: 'Copiado!',
    copy: 'Copiar',
    howToPay: 'Como Pagar',
    step1: 'Abra o aplicativo do seu banco',
    step2: 'Escolha a opção PIX → Copia e Cola',
    step3: 'Cole o código PIX copiado acima',
    step4: 'Confira o valor de R$ {amount}',
    step5: 'Finalize o pagamento',
    step6: 'Entre em contato com o suporte para confirmar',
    paymentConfirmation: 'Confirmação de Pagamento',
    paymentConfirmText: 'Após realizar o pagamento, entre em contato para ativar suas tabs:',
    backToPackages: 'Voltar aos Pacotes',
    securePayment: 'Pagamento Seguro: Utilize PIX para transferência instantânea e segura.',
    fastActivation: 'Ativação Rápida: Suas tabs serão ativadas em até 24 horas após confirmação.',
    support: 'Suporte: Estamos aqui para ajudar via WhatsApp ou Email.',
    whatsAppMsg: 'Olá! Gostaria de confirmar meu pagamento de R$ {amount} referente a {tabs} tab(s) por {months} mês(es). Minha conta: "{username}", aguardo retorno. Obrigado!',
    emailSubject: 'Confirmação de Pagamento - Unity Tabs',
    emailBody: 'Olá,\n\nRealizei o pagamento de R$ {amount} via PIX para aquisição de {tabs} tab(s) por {months} mês(es).\n\nChave PIX: {key}\n\nAguardo confirmação.\n\nObrigado! Minha conta: "{username}"',
    unityBot: 'Unity-BOT',
    version: 'Versão {v}',
    installerAvailable: 'Instalador Disponível',
    yes: 'Sim',
    no: 'Não',
    size: 'Tamanho',
    published: 'Publicado',
    fullInstaller: 'Instalador Completo',
    downloading: 'Baixando...',
    updatePatch: 'Patch de Update',
    recentUpdates: 'Atualizações Recentes',
    new: 'NOVO',
    showLess: 'Mostrar Menos',
    showAll: 'Mostrar Todas ({n} mais)',
    botConfig: 'Config.',
    telegram: 'Telegram',
    binds: 'Binds',
    unreal: 'Unreal',
    lifeIns: 'Life Ins.',
    savedTelegram: 'Configs de Telegram ({n})',
    noTelegram: 'Nenhuma config de telegram',
    tab: 'Tab {name}',
    savedBinds: 'Binds Salvos ({n})',
    noBinds: 'Nenhum bind salvo',
    bindEntry: '{name}@{world}',
    bindType: '[{type}] {path}',
    savedCredentials: 'Credenciais Salvas ({n})',
    noCredentials: 'Nenhuma credencial',
    credentialEntry: '{name}@{world}',
    passwordSaved: 'Senha salva',
    savedPreferences: 'Preferências Salvas ({n})',
    noPreferences: 'Nenhuma preferência',
    prefEntry: '{char}@{world}',
    prefValue: 'Valor: {data}',
    supportTab: 'Suporte',
    contactSupport: 'Fale Conosco',
    whatsApp: 'WhatsApp',
    email: 'Email',
    serverStatus: 'Status do Servidor',
    loadingServer: 'Carregando status do servidor...',
    estimatedRecovery: 'Recuperação estimada: {date}',
    quickFaq: 'FAQ Rápido',
    faq1q: 'Como ativo minhas tabs após a compra?',
    faq1a: 'Entre em contato pelo WhatsApp ou Email com seu comprovante de pagamento. As tabs geralmente são ativadas em até 24 horas.',
    faq2q: 'Onde posso baixar o bot?',
    faq2a: 'Vá até a aba Unity-BOT neste painel para baixar o instalador completo ou patch de atualização.',
    faq3q: 'Como solicito reembolso?',
    faq3a: 'Entre em contato com nossa equipe de suporte pelo WhatsApp ou Email. Os reembolsos são processados caso a caso.',
    faq4q: 'Por que minha conta foi suspensa?',
    faq4a: 'Verifique a aba Informações para detalhes sobre o status da sua conta. Se acredita que foi um erro, entre em contato com o suporte.',
    loadProfileFailed: 'Falha ao carregar perfil',
    loadInfoFailed: 'Não foi possível carregar informações da conta',
    nicknameUpdated: 'Apelido atualizado com sucesso!',
    nicknameUpdateFailed: 'Falha ao atualizar apelido',
    errorTryAgain: 'Ocorreu um erro. Tente novamente.',
    errorOccurred: 'Ocorreu um erro',
  },
  admin: {
    panelTitle: 'Painel Admin',
    clients: 'Clientes',
    server: 'Servidor',
    stats: 'Estatísticas',
    bot: 'Unity-BOT',
    resources: 'Recursos',
    gms: 'GMs',
    news: 'Notícias',
    dashboard: 'Painel',
    overview: 'Visão Geral',
    accounts: 'Contas',
    onlineActivity: 'Atividade Online',
    characters: 'Personagens',
    liveWorld: 'Mundo Online',
    licenses: 'Licenças',
    gameMasters: 'Game Masters',
    totalAccounts: 'Total de Contas',
    onlineNow: 'Online Agora',
    app: 'APP',
    site: 'Site',
    totalChars: 'Total de Personagens',
    online: 'online',
    unique: 'únicos',
    noDuplicates: 'sem duplicatas',
    totalGMs: 'Total de GMs',
    active: 'ativo',
    statusBreakdown: 'Distribuição de Status',
    accountInfo: 'Info da Conta',
    emailVerified: 'Email verificado',
    withNickname: 'Com apelido',
    withLicense: 'Com licença',
    created: 'Criados ({period})',
    createdShort: 'Criado em',
    appOnline: 'APP Online',
    siteOnline: 'Site Online',
    charsOnline: 'Personagens Online',
    perWorld: 'Por Mundo',
    noWorlds: 'Nenhum mundo encontrado',
    avgPerAccount: 'Média por conta',
    withoutChars: 'Sem personagens',
    uniqueChars: 'Personagens únicos',
    onlineNow_: 'Online agora',
    population: 'População',
    totalCharacters: 'Total de Personagens',
    activeAccounts: 'Contas Ativas',
    licenseSummary: 'Resumo de Licenças',
    licensesIssued: 'Licenças emitidas',
    permanentTabs: 'Tabs permanentes',
    newTabPackages: 'Pacotes NewTab',
    totalPackages: 'Total de pacotes',
    activePackages: 'Pacotes ativos',
    expired: 'Expirados',
    activeQuantity: 'Quantidade ativa',
    activeGMs: 'Ativos',
    seenToday: 'Vistos Hoje',
    seenThisWeek: 'Vistos Esta Semana',
    in24h: 'em 24h',
    of: 'de',
    period24h: '24h',
    period7d: '7 dias',
    period30d: '30 dias',
    periodAll: 'Todo período',
    noData: 'Sem dados',
    registeredClients: 'Clientes Registrados ({n})',
    totalClients: 'Total de Clientes',
    bannedSuspended: 'Banidos/Suspensos',
    verifiedEmail: 'Email Verificado',
    appOnlineShort: 'APP Online',
    siteOnlineShort: 'Site Online',
    totalCharsShort: 'Total Pers.',
    avgClient: 'média/cliente',
    charsOnlineShort: 'Pers. Online',
    without: 'sem',
    uniqueCharsShort: 'Pers. Únicos',
    pax: 'PAX',
    gmsActive: 'GMs Ativos',
    gmsCount: '{n} GM{s}',
    status: 'Status:',
    search: 'Buscar por usuário, email...',
    filters: 'Filtros',
    withChars: 'Com Personagens',
    withoutChars_: 'Sem',
    sort: 'Ordenar:',
    created: 'Criação',
    lastLogin: 'Último Login',
    username: 'Usuário',
    previous: 'Anterior',
    next: 'Próximo',
    page: 'Página {n} de {total}',
    serverControl: 'Controle do Servidor',
    changeStatus: 'Alterar Status do Servidor',
    statusMessage: 'Mensagem de Status (Opcional)',
    messagePlaceholder: 'Ex.: Manutenção programada para atualizações',
    estimatedRecovery_: 'Recuperação Estimada (Opcional)',
    currentStatus: 'Status Atual',
    modifiedBy: 'Modificado por',
    serverOnline: 'Online',
    serverOnlineDesc: 'Operação normal',
    serverDegraded: 'Degradado',
    serverDegradedDesc: 'Desempenho reduzido',
    serverUpdating: 'Atualizando',
    serverUpdatingDesc: 'Instalando atualizações',
    serverRestarting: 'Reiniciando',
    serverRestartingDesc: 'Reiniciando serviços',
    serverMaintenance: 'Manutenção',
    serverMaintenanceDesc: 'Em manutenção',
    serverOffline: 'Offline',
    serverOfflineDesc: 'Servidor offline',
    lastUpdated: 'Última atualização:',
    overview_: 'Visão Geral',
    onlineActivity_: 'Atividade Online',
    worlds: 'Mundos',
    clientDetails: 'Detalhes do Cliente',
    infoTab: 'Informações',
    charactersTab: 'Personagens',
    sessionsTab: 'Sessões',
    actionsTab: 'Ações',
    manageTabs: 'Gerenciar Tabs',
    ban: 'Banir',
    unban: 'Desbanir',
    deleteClient: 'Excluir Cliente',
    editDetails: 'Editar Detalhes',
    forceLogout: 'Forçar Logout',
    editLicenseNotes: 'Editar Observações',
    noSessions: 'Nenhuma sessão encontrada',
    sessionType: 'Tipo',
    device: 'Dispositivo',
    ip: 'IP',
    active_: 'Ativa',
    revoked: 'Revogada',
    overview: 'Visão Geral',
    installer: 'Instalador',
    versions: 'Versões',
    changelog: 'Changelog',
    manageFiles: 'Gerenciar Arquivos',
    uploadFiles: 'Enviar Arquivos',
    map: 'Mapa',
    gmStats: 'Stats de GMs',
    addGM: 'Adicionar GM',
    editGM: 'Editar GM',
    deleteGM: 'Excluir GM',
    gmName: 'Nome',
    gmNotes: 'Observações',
    gmActive: 'Ativo',
    gmInactive: 'Inativo',
    showInactive: 'Mostrar inativos/expirados',
    noGMs: 'Nenhum Game Master visto recentemente',
    createAnnouncement: 'Criar Anúncio',
    editAnnouncement: 'Editar Anúncio',
    deleteAnnouncement: 'Excluir Anúncio',
    title: 'Título',
    content: 'Conteúdo',
    type: 'Tipo',
    priority: 'Prioridade',
    publishDate: 'Data de Publicação',
    expirationDate: 'Data de Expiração',
    // Bot Manager
    newVersion: '+ Nova Versão',
    createVersion: 'Criar Versão',
    creating: 'Criando...',
    versionCreated: 'criada com sucesso',
    versionDeleted: 'excluída',
    versionUnpublished: 'despublicada',
    mandatory: 'OBRIGATÓRIO',
    mandatoryUpdate: 'Atualização Obrigatória',
    hide: 'Ocultar',
    publish: 'Publicar',
    unpublish: 'Despublicar',
    edit: 'Editar',
    editChangelog: 'Editar Changelog',
    downloadZip: 'Baixar ZIP',
    publishConfirm: 'Publicar {label} {version}? Ela se tornará publicamente disponível.',
    unpublishConfirm: 'Despublicar versão {version}? Ela será removida do acesso público.',
    deleteVersionConfirm: 'Excluir versão {version}? Esta ação não pode ser desfeita e excluirá todos os arquivos associados.',
    changelogUpdated: 'Changelog atualizado para v{version}',
    changelogUpdateFailed: 'Falha ao atualizar changelog',
    changelogPerLine: '(uma alteração por linha)',
    versionPlaceholder: 'Ex.: {example}',
    versionRequired: 'Versão e Changelog são obrigatórios',
    updatePatchRequired: 'Arquivo de patch de atualização é obrigatório',
    createVersionFailed: 'Falha ao criar versão',
    createVersionError: 'Falha ao criar versão: {error}',
    publishFailed: 'Falha ao publicar',
    unpublishFailed: 'Falha ao despublicar',
    deleteVersionFailed: 'Falha ao excluir',
    // Installer
    selectInstallerFile: 'Selecione um arquivo de instalador (.exe)',
    installerUploaded: 'Instalador enviado: {size}',
    installerUploadFailed: 'Falha ao enviar instalador',
    installerUploadError: 'Falha ao enviar instalador: {error}',
    onlyExeAllowed: 'Apenas arquivos .exe são permitidos',
    installerDesc1: 'O instalador é',
    installerDescBold: 'independente das versões',
    installerDesc2: 'Envie um novo arquivo .exe para substituir o instalador atual. Isso afetará todos os novos downloads da página pública.',
    installerFileLabel: 'Arquivo do Instalador (.exe)',
    installerDropzoneText: 'Clique para selecionar ou arraste o arquivo do instalador',
    installerDropzoneHint: 'Apenas .exe (máx. 500 MB)',
    uploading: 'Enviando...',
    filesSelected: '{n} arquivo(s) selecionado(s)',
    filesDropzoneText: 'Clique para selecionar ou arraste os arquivos de atualização',
    filesDropzoneHint: 'Opcional \u2022 DLLs, configs, etc \u2022 Máx. 50 arquivos',
    willBeZipped: '(será zipado)',
    changelogPlaceholder: "Correção de crash ao abrir inventário\nAdicionado suporte a novo mapa\nMelhorias de desempenho",
    shareUpdate: 'Compartilhar esta atualização',
    // Resources Manager
    failedToLoadMapStatus: 'Falha ao carregar status do mapa',
    confirmMapUpload: 'Enviar "{filename}" como map.bin? Isso substituirá o mapa atual.',
    mapUploadedSuccessfully: 'Mapa enviado com sucesso! ({size})',
    failedToUploadMap: 'Falha ao enviar mapa',
    mapDownloadStarted: 'Download do mapa iniciado!',
    failedToDownloadMap: 'Falha ao baixar mapa',
    filesRejected: '{count} arquivo(s) rejeitado(s): {description} só aceita {extensions}',
    onlyBinFilesAllowed: 'Apenas arquivos .bin são permitidos para upload de mapa',
    notAvailable: 'N/D',
    failedToLoadManifest: 'Falha ao carregar manifesto',
    pleaseSelectAtLeastOneFile: 'Selecione pelo menos um arquivo para enviar',
    allFilesUploadedSuccessfully: 'Todos os {count} arquivo(s) enviados com sucesso!',
    allFilesFailedToUpload: 'Todos os {count} arquivo(s) falharam ao enviar',
    someFilesUploadedWithFailures: '{successCount} arquivo(s) enviados, {failureCount} falharam',
    failedToUploadFiles: 'Falha ao enviar arquivos',
    confirmDeleteFile: 'Tem certeza que deseja excluir "{filename}" de {category}?',
    fileDeletedSuccessfully: 'Arquivo "{filename}" excluído com sucesso!',
    failedToDeleteFile: 'Falha ao excluir arquivo',
    noFilesToDeleteInCategory: 'Nenhum arquivo para excluir nesta categoria',
    confirmDeleteAllFiles: '⚠️ EXCLUIR TODOS OS ARQUIVOS?\n\nIsso excluirá permanentemente TODOS os {count} arquivo(s) de {category}.\n\nEsta ação não pode ser desfeita!',
    deleteAllFilesTitle: 'Excluir Todos os Arquivos',
    categoryDeletedSuccessfully: '{count} arquivo(s) excluído(s) de {category} com sucesso!',
    failedToDeleteCategoryFiles: 'Falha ao excluir arquivos da categoria',
    confirmSyncFilesystem: 'Sincronizar filesystem com o banco de dados? Isso irá escanear todos os arquivos e atualizar o banco.',
    filesystemSyncedSuccessfully: 'Filesystem sincronizado com sucesso!',
    failedToSyncFilesystem: 'Falha ao sincronizar filesystem',
    preparingDownload: 'Preparando download...',
    downloadStarted: 'Download iniciado!',
    failedToDownloadResources: 'Falha ao baixar recursos',
    clickToSelectOrDragDropFiles: 'Clique para selecionar ou arraste arquivos aqui',
    clearAll: 'Limpar tudo',
    filesSelected: '{count} arquivo(s) selecionado(s)',
    uploadFilesWithCount: 'Enviar {count} Arquivo(s)',
    confirmUpload: 'Confirmar Upload',
    files: 'arquivos',
    willBeUploaded: 'serão enviados',
    cancel: 'Cancelar',
    uploading: 'Enviando...',
    results: 'Resultados',
    successfulCount: '✅ {count} Sucesso',
    failedCount: '❌ {count} Falha',
    mapStatus: 'Status do Mapa',
    downloadMapBin: 'Baixar map.bin',
    mapNotAvailable: 'Mapa não disponível',
    refresh: 'Atualizar',
    file: 'Arquivo',
    mapBinPresent: '✅ map.bin presente',
    noMapUploaded: '⚠️ Nenhum mapa enviado',
    size: 'Tamanho',
    lastModified: 'Última modificação',
    tilesInQueue: 'Tiles na fila',
    clickRefreshToLoadMapStatus: 'Clique em atualizar para carregar o status do mapa',
    uploadMapBin: 'Enviar map.bin',
    mapUploadDescReplaces: 'Substitui o atual autoritativo',
    mapUploadDescFormat: 'Formato: binário raw',
    clickToSelectOrDragDropBin: 'Clique para selecionar ou arraste arquivo .bin',
    deleteAllFromCategory: 'Excluir todos os {count} arquivo(s) de {category}',
    deleteAll: 'Excluir Tudo',
    noFilesInThisCategory: 'Nenhum arquivo nesta categoria',
    deleteFile: 'Excluir arquivo',
    categoryFileCount: '({count})',
    category: {
      java: 'Arquivos Java (Cliente)',
      lib: 'DLLs de Biblioteca (Bot)',
      x32: 'DLLs x32 (Cliente)',
      x64: 'DLLs x64 (Cliente)',
      audio: 'Arquivos de Áudio (Bot)',
      ui: 'Arquivos de Configuração UI (Cliente)',
      packs: 'Packs de Recursos (Cliente)',
    },
    // GMs
    gmLoadFail: 'Falha ao carregar GMs',
    gmNameRequired: 'Nome é obrigatório',
    gmUpdateSuccess: 'GM atualizado',
    gmCreateSuccess: 'GM criado',
    gmSaveFail: 'Falha ao salvar GM',
    gmDeleteConfirm: 'Excluir GM "{name}"?',
    gmDeleteUndoable: 'Esta ação não pode ser desfeita.',
    gmDeleteSuccess: 'GM "{name}" excluído',
    gmDeleteFail: 'Falha ao excluir GM',
    // Announcements
    annLoadFail: 'Falha ao carregar anúncios',
    annTitleContentRequired: 'Título e conteúdo são obrigatórios',
    annUpdateSuccess: 'Anúncio atualizado',
    annCreateSuccess: 'Anúncio criado',
    annSaveFail: 'Falha ao salvar anúncio',
    annDeleteConfirm: 'Excluir anúncio "{title}"?',
    annDeleteUndoable: 'Isto não pode ser desfeito.',
    annDeleteSuccess: '"{title}" excluído',
    annDeleteFail: 'Falha ao excluir',
    alert: 'Alerta',
    // Remaining admin keys
    failedToLoadData: 'Falha ao carregar dados',
    serverStatusChanged: 'Status do servidor alterado para {status} com sucesso!',
    updateStatusFailed: 'Falha ao atualizar status do servidor',
    updateStatusError: 'Ocorreu um erro ao atualizar o status do servidor',
    tabsHeader: 'Tabs',
    botDataLoadFailed: 'Falha ao carregar dados do bot',
  },
  server: {
    online: 'Online',
    offline: 'Offline',
    maintenance: 'Manutenção',
    updating: 'Atualizando',
    degraded: 'Degradado',
    restarting: 'Reiniciando',
    unknown: 'Desconhecido',
    justNow: 'Agora mesmo',
    minsAgo: '{n}min atrás',
    hoursAgo: '{n}h atrás',
    failedToLoad: 'Falha ao carregar status do servidor',
    appLabel: 'App',
    webLabel: 'Web',
    charsLabel: 'Pers.',
  },
  announcements: {
    latestNews: 'Últimas Notícias',
  },
  character: {
    level: 'Nível {n}',
    world: 'Mundo {world}',
    unknown: 'Desconhecido',
    online: 'Online',
    offline: 'Offline',
    deleteTitle: 'Excluir personagem',
    tabCharacter: 'Personagem',
    combat: 'Combate',
    automation: 'Automação',
    technical: 'Técnico',
    hp: 'HP',
    mp: 'MP',
    experience: 'Experiência',
    toNextLevel: 'Para Próximo Nível',
    gold: 'Ouro',
    stamina: 'Stamina',
    lifeInsurance: 'Seguro de Vida',
    highscore: 'Highscore',
    guild: 'Guilda',
    name: 'Nome',
    rank: 'Ranque',
    rankings: 'Ranques',
    pvpRank: 'Ranque PVP',
    boosts: 'Boosters',
    epBoost: 'Boost de EP',
    goldBoost: 'Boost de Ouro',
    itemBonusEP: 'Bônus de Item EP',
    itemBonusGold: 'Bônus de Item Ouro',
    protections: 'Proteções',
    hit: 'Golpe',
    fire: 'Fogo',
    ice: 'Gelo',
    soul: 'Alma',
    lightning: 'Raio',
    skills: 'Habilidades',
    attackSkill: 'Ataque',
    defenseSkill: 'Defesa',
    currentMonster: 'Monstro Atual',
    killedMonsters: 'Monstros Mortos',
    script: 'Script',
    scriptName: 'Nome do Script',
    currentAction: 'Ação Atual',
    saCombo: 'Combo SA',
    saLine: 'Linha SA',
    movementSpeed: 'Velocidade',
    autoMove: 'Mov. Automático',
    autoSA: 'SA Automático',
    enabled: 'Ativado',
    disabled: 'Desativado',
    performance: 'Desempenho',
    expPerHour: 'EXP/Hora',
    goldPerHour: 'Ouro/Hora',
    expReceived: 'EXP Recebido',
    goldReceived: 'Ouro Recebido',
    session: 'Sessão',
    huntTime: 'Tempo de Caça',
    totalSteps: 'Passos Totais',
    reloginTime: 'Tempo de Relogin',
    lastDisconnect: 'Última Desconexão',
    connection: 'Conexão',
    state: 'Estado',
    serverInfo: 'Info do Servidor',
    premium: 'Premium',
    banStatus: 'Status de Ban',
    bind: 'Bind',
    location: 'Localização',
    x: 'X',
    y: 'Y',
    z: 'Z',
    identifiers: 'Identificadores',
    characterId: 'ID do Personagem',
    clientId: 'ID do Cliente',
    timestamps: 'Carimbos',
    created: 'Criado',
    lastUpdated: 'Última Atualização',
    confirmDelete: 'Confirmar Exclusão',
    deleteMessage: 'Tem certeza que deseja excluir {name} do Mundo {world}?',
    deleteWarning: 'Esta ação não pode ser desfeita.',
    deleting: 'Excluindo...',
    delete: 'Excluir',
    deleteFailed: 'Falha ao excluir personagem. Tente novamente.',
    none: 'Nenhum',
  },
  tabs: {
    title: 'Tabs - {username}',
    totalTabs: 'Total de Tabs',
    permanent: 'Permanente',
    temporary: 'Temporário',
    addTabs: 'Adicionar Tabs',
    removeTabs: 'Remover Tabs',
    permanentOption: 'Permanente (∞)',
    temporaryOption: 'Temporário (⏳)',
    quantity: 'Quantidade',
    expiresAt: 'Expira em',
    plus1Month: '+1 Mês',
    plus6Months: '+6 Meses',
    descriptionOptional: 'Descrição (Opcional)',
    adding: 'Adicionando...',
    addTabsBtn: 'Adicionar Tabs',
    removePermanentTabs: 'Remover Tabs Permanentes',
    amountToRemove: 'Quantidade a Remover (Máx: {n})',
    removeTabsBtn: 'Remover Tabs',
    temporaryTabPackages: 'Pacotes de Tabs Temporárias',
    expired: 'Expirado',
    active: 'Ativo',
    expires: 'Expira:',
    addedBy: 'Adicionado por:',
    deletePackage: 'Excluir Pacote',
    modifiedBy: 'Modificado por:',
    lastUpdated: 'Última Atualização:',
    created: 'Criado:',
    noLicense: 'Nenhuma licença encontrada para este cliente.',
    createLicense: 'Criar Licença com Tabs',
    qtyMin1: 'A quantidade deve ser pelo menos 1',
    expirationRequired: 'Data de expiração é obrigatória para tabs temporárias',
    addSuccessPermanent: '{n} tabs permanentes adicionadas com sucesso!',
    addSuccessTemporary: '{n} tabs temporárias adicionadas com sucesso!',
    removeSuccess: '{n} tabs permanentes removidas com sucesso!',
    deleteSuccess: 'Pacote newtab excluído com sucesso!',
    updateSuccess: 'Newtab atualizado com sucesso!',
    addFailed: 'Falha ao adicionar tabs',
    removeFailed: 'Falha ao remover tabs',
    deleteFailed: 'Falha ao excluir newtab',
    updateFailed: 'Falha ao atualizar newtab',
    loadFailed: 'Falha ao carregar dados da licença',
    removeConfirm: 'Remover {n} tabs permanentes de {username}?',
    deleteConfirm: 'Excluir este pacote de tabs temporárias?',
    amountMin1: 'A quantidade deve ser pelo menos 1',
    errorOccurred: 'Ocorreu um erro ao adicionar tabs',
    errorRemove: 'Ocorreu um erro ao remover tabs',
    errorDelete: 'Ocorreu um erro ao excluir newtab',
    errorUpdate: 'Ocorreu um erro ao atualizar newtab',
    descPlaceholder: 'Ex.: Assinatura mensal',
    addedByAdmin: 'Adicionado por admin',
    none: 'Nenhum',
    never: 'Nunca',
  },
  ban: {
    title: 'Banir Cliente: {username}',
    banType: 'Tipo de Ban',
    permanentBan: 'Ban Permanente',
    permanentDesc: 'Cliente será banido indefinidamente',
    temporarySuspension: 'Suspensão Temporária',
    temporaryDesc: 'Cliente será desbanido automaticamente',
    reason: 'Motivo (Opcional)',
    reasonPlaceholder: 'Digite o motivo para este ban (ex.: \'Violou termos de uso\', \'Comportamento inadequado\')...',
    charCount: '{n}/500 caracteres',
    expirationDateTime: 'Data e Hora de Expiração',
    date: 'Data',
    time: 'Hora',
    autoUnban: 'O cliente será desbanido automaticamente na data e hora especificadas',
    preview: 'Visualizar',
    client: 'Cliente:',
    type: 'Tipo:',
    permanent: 'Permanente',
    temporary: 'Temporário',
    expires: 'Expira:',
    processing: 'Processando...',
    confirmBan: 'Confirmar Ban',
  },
  confirm: {
    title: 'Confirmar',
    confirm: 'Confirmar',
  },
  share: {
    shareUpdate: 'Compartilhar Atualização',
    badgeLatest: 'MAIS RECENTE',
    badgeUpdate: 'ATUALIZAÇÃO',
    mandatory: 'OBRIGATÓRIO',
    whatsNew: '✦ Novidades ✦',
    whatsApp: 'WhatsApp',
    image: 'Imagem',
    copy: 'Copiar',
    statusWhatsApp: 'WhatsApp aberto!',
    statusCopied: 'Texto copiado!',
    statusGenerating: 'Gerando imagem...',
    statusDownloaded: 'Imagem baixada!',
    statusError: 'Algo deu errado',
    cardBrand: 'UNITY-BOT',
    na: 'N/D',
    whatsAppTitle: '🏰 *ATUALIZAÇÃO Unity-BOT v{version}* 🏰',
    whatsAppChanges: '✨ *Novidades:*',
    whatsAppDownload: '⬇️ Download: unity-bot.com',
  },
  langSwitcher: {
    pt: 'Português (BR)',
    en: 'English (US)',
  },
  loading: {
    loading: 'Carregando...',
  },
  app: {
    errorTitle: 'Algo deu errado',
    errorDesc: 'Ocorreu um erro inesperado',
    clearSession: 'Limpar Sessão & Recarregar',
  },
}
